// タブのタイプ
export type PLAN_TAB_TYPE =
  | "none"
  | "live"
  | "movie"
  | "talk"
  | "document"
  | "content"
  | "library"
  // | "owner_profile"
  | "article"
  | "overview"
  | "member_list";

// 講座画面タブメニュー定義
export default Object.freeze({
  LIVE: {
    value: "live",
    title: "ライブ",
    icon: "plan_live",
  },
  MOVIE: {
    value: "movie",
    title: "動画",
    icon: "plan_movie",
  },
  TALK: {
    value: "talk",
    title: "トーク",
    icon: "plan_talk",
  },
  DOCUMENT: {
    value: "document",
    title: "資料",
    icon: "plan_document",
  },
  CONTENT: {
    value: "content",
    title: "コンテンツ",
    icon: "plan_document",
  },
  LIBRARY: {
    value: "library",
    title: "セレクション",
    icon: "plan_library",
  },
  OVERVIEW: {
    value: "overview",
    title: "講座の紹介",
    icon: "plan_overview",
  },
  MEMBER_LIST: {
    value: "member_list",
    title: "講座管理",
    icon: "plan_member",
  },
  ARTICLE: {
    value: "article",
    title: "記事",
    icon: "article",
  },
}) as Record<string, { value: PLAN_TAB_TYPE; title: string }>;
